import script from "./SavingsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavingsCard.vue?vue&type=script&setup=true&lang=ts"

import "./SavingsCard.vue?vue&type=style&index=0&id=38a408a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a408a1"]])

export default __exports__